import { render, staticRenderFns } from "./upgrade-package.vue?vue&type=template&id=6ddd5ca6&scoped=true&"
import script from "./upgrade-package.vue?vue&type=script&lang=js&"
export * from "./upgrade-package.vue?vue&type=script&lang=js&"
import style0 from "./upgrade-package.vue?vue&type=style&index=0&id=6ddd5ca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddd5ca6",
  null
  
)

export default component.exports